export default "__VITE_ASSET__C$fjRYwx__"